import { render, staticRenderFns } from "./topicsDiscover.vue?vue&type=template&id=19750017&scoped=true"
import script from "./topicsDiscover.vue?vue&type=script&lang=js"
export * from "./topicsDiscover.vue?vue&type=script&lang=js"
import style0 from "./topicsDiscover.vue?vue&type=style&index=0&id=19750017&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19750017",
  null
  
)

export default component.exports